import Vue from 'vue'

const BaseComponents = [
  'BaseCheckboxGroup',
  'BaseForm',
  'BaseRadioGroup',
  'BaseSelect',
  'BaseSelectTree',
  'BaseTree',
  'BaseUpload',
  'BaseTable',
  'BaseDialog',
  'BaseEmpty',
  'BaseTitle',
  'BaseSearch'
]

BaseComponents.forEach((componentName) => {
  const component = require(`./${componentName}/index.vue`)

  Vue.component(componentName, component.default)
})
